import React from 'react';
export default function SendTextEditor({ value, onChange }) {
  return (
    <div style={{ padding:16 }}>
      <label style={{ fontSize:11, fontWeight:700, color:'#475569', display:'block', marginBottom:6, textTransform:'uppercase', letterSpacing:'0.06em' }}>Message Text</label>
      <textarea
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        onKeyDown={e => e.stopPropagation()}
        placeholder="Type your message... Use {{variable}} for substitution"
        rows={4}
        style={{ width:'100%', padding:'8px 10px', border:'1px solid #e2e8f0', borderRadius:8, fontSize:12, color:'#0f172a', resize:'vertical', outline:'none', boxSizing:'border-box', fontFamily:'inherit' }}
      />
      <p style={{ fontSize:10, color:'#94a3b8', marginTop:6 }}>Use {'{{variable_name}}'} for dynamic values.</p>
    </div>
  );
}
